import { useEditor } from "features/editor/Feature";
import { useSession } from "hooks/api/useSession";
import React from "react";

import { useActiveWorkspace } from "hooks/useActiveWorkspace";
import { useActiveWorkspaceSubscription } from "hooks/useActiveWorkspaceSubscription";

import { CloseToOutOfCredits } from "./CloseToOutOfCredits";
import { CloseToSpendingLimit } from "./CloseToSpendingLimit";
import { PaymentPending } from "./PaymentPending";

export const StripeMessages = React.memo(() => {
  const [session] = useSession();
  const editor = useEditor();

  const isDevbox =
    editor.type === "branch" || (editor.type === "sandbox" && editor.isCloud);
  const activeWorkspace = useActiveWorkspace();
  const { hasPendingPayment, isTeamAdmin, isFree, isPro, subscription } =
    useActiveWorkspaceSubscription();

  const { workspace } = editor;

  // Don't show this for unauthenticated users or linked repos.
  if (session.state !== "AUTHENTICATED" || workspace?.id === undefined) {
    return null;
  }

  const sandboxFromActiveWorkspace = workspace.id === activeWorkspace?.id;

  if (hasPendingPayment) {
    return (
      <PaymentPending
        isTeamAdmin={isTeamAdmin}
        status={subscription.status}
        teamId={activeWorkspace?.id}
      />
    );
  }

  if (isDevbox && isFree && sandboxFromActiveWorkspace) {
    return (
      <CloseToOutOfCredits isAdmin={isTeamAdmin} workspace={activeWorkspace} />
    );
  }

  if (isDevbox && isPro && sandboxFromActiveWorkspace) {
    return (
      <CloseToSpendingLimit isAdmin={isTeamAdmin} workspace={activeWorkspace} />
    );
  }

  return null;
});
